import React, { Component } from "react";
import { Paper, IconButton, Grid, Typography } from "@material-ui/core";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

import ClearIcon from "@material-ui/icons/Clear";
import moment from "moment";
import { formatDate, parseDate } from "react-day-picker/moment";
class DateRangePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: false,
            fromDate: false,
        };
    }

    render() {
        const { fromDate, toDate } = this.state;
        const { sm, md, lg } = this.props;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper style={{ padding: 24, height: "100%" }}>
                    <Typography variant="h5">Date Range Picker</Typography>
                    <DayPickerInput
                        style={{ margin: 4 }}
                        value={fromDate || ""}
                        placeholder="Single Date"
                        label="Single Date"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        format="DD/MM/YYYY"
                        onDayChange={(day) => {
                            this.setState({
                                fromDate: moment(day).format("DD/MM/YYYY"),
                            });
                            this.props.fromDateCallback(
                                moment(day).format("DD/MM/YYYY")
                            );
                        }}
                    />
                    --
                    <DayPickerInput
                        style={{ margin: 4 }}
                        value={toDate || ""}
                        label="End Date"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        placeholder="End Date"
                        format="DD/MM/YYYY"
                        onDayChange={(day) => {
                            this.setState({
                                toDate: moment(day).format("DD/MM/YYYY"),
                            });

                            this.props.toDateCallback(
                                moment(day).format("DD/MM/YYYY")
                            );
                        }}
                    />
                    <IconButton
                        style={{
                            marginLeft: 5,
                            marginTop: -3,
                            color: "red",
                            border: "1px solid red",
                        }}
                        color="primary"
                        variant="outlined"
                        onClick={() => {
                            this.setState({
                                toDate: false,
                                fromDate: false,
                            });
                            this.props.toDateCallback(false);
                            this.props.fromDateCallback(false);
                        }}
                    >
                        <ClearIcon />
                    </IconButton>
                </Paper>
            </Grid>
        );
    }
}

export default hot(module)(
    connect((store) => {
        return {};
    }, {})(DateRangePicker)
);
